import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faBan } from '@fortawesome/free-solid-svg-icons';

const QueueTimes = (props) => {
  const { timex } = props;

  const [time, setTime] = useState({ currentTime: timex }) 

  const timer = () => setTime((prevState) => { 
    return { currentTime: prevState.currentTime + 1 }
  });
  
  useEffect(() => {
    const intervalId = setInterval(() => timer(), 1000)

    return () => clearInterval(intervalId);
  }, [timex]);
  
  return (
      <td>{ time.currentTime }</td>
  )
}

export default QueueTimes;